import VueRouter from 'vue-router'
import Error404 from'./components/error404'
import ExtraDruckVorlagen from './components/extras/extra-druck-vorlagen'
import ExtraFormularResults from './components/extras/extra-formular-results'
import ExtraItTicketCenter from './components/extras/extra-it-ticket-center'
import ExtraItTicketStatistik from './components/extras/extra-it-ticket-statistik'
import ExtraItTicketVorgabenBearbeiten from './components/extras/extra-it-ticket-vorgaben-bearbeiten'
import ExtraItTicketVorgaengeBearbeiten from './components/extras/extra-it-ticket-vorgaenge-bearbeiten'
import ExtraMenusBearbeiten from './components/extras/extra-menus-bearbeiten'
import ExtraNeuesGeraetHinzufuegen from './components/extras/extra-neues-geraet-hinzufuegen'
import ExtraInventar from './components/extras/extra-inventar'
import ExtraProjekteStatus from './components/extras/extra-projekte-status'
import ExtraProzesse from './components/extras/extra-prozesse'
import ExtraPatientenverfuegung from './components/extras/extra-patientenverfuegung'
import ExtraQrCodeGenerator from './components/extras/extra-qrcode-generator'
import LayoutAdmin from './components/layout-admin'
import Layout from './components/layout'
import { sortBy } from 'lodash'


function buildChildMenuTree(menu, menus) {
  let ancestry = menu.ancestry ? `${menu.ancestry}/${menu.id}` : `${menu.id}`
  menu.children = menus.filter(m => {
    if (m.ancestry === ancestry) {
      buildChildMenuTree(m, menus)
      return true
    }
  })
}

function buildMenuTree(menus) {
  if (menus) {
    return menus.filter(m => !m.ancestry).reduce((all, root) => {
      buildChildMenuTree(root, menus)
      all[root.name] = root
      return all
    }, {})
  }
  return {}
}

function buildMenuRoutes(menu, routes, parentPath) {
  if (typeof menu.slug === 'string') {
    let name = `menu-item-${menu.id}`
    menu.route = { name }
    if ( menu.slug !== '') {
      let childName = `${name}-page`
      menu.pageRoute = { childName }
      routes.push({ path: `/${menu.slug}/:slug`, name: childName, component: Layout, props: { menu: menu, isPage: true } })
    }
    routes.push({ path: `/${menu.slug}`, name, component: Layout, props: { menu: menu, isPage: false } })
  }
  if (menu.children.length) {
    menu.children.forEach(m => buildMenuRoutes(m, routes, parentPath))
  }
}

const menus = buildMenuTree(sortBy(dataVueApp.menus, 'position'))
const kategorien = buildMenuTree(sortBy(dataVueApp.kategorien, 'position'))

const user = dataVueApp.user

const routes = [
  { path: '/admin', name: 'admin', component: LayoutAdmin, children: [
    { path: 'druckvorlagen', name: 'admin-druck-vorlagen', component: ExtraDruckVorlagen, meta: { container: false } },
    { path: 'formulare', name: 'admin-formulare', component: ExtraFormularResults, meta: { container: true } },
    { path: 'ticket_center', name: 'admin-it-ticket-center', component: ExtraItTicketCenter, meta: { container: true } },
    { path: 'it_ticket_statistik', name: 'admin-it-ticket-statistik', component: ExtraItTicketStatistik, meta: { container: true } },
    { path: 'bestellungen', name: 'admin-bestellungen', component: ExtraItTicketVorgaengeBearbeiten, meta: { container: true } },
    { path: 'menue_bearbeiten', name: 'admin-menue-bearbeiten', component: ExtraMenusBearbeiten, meta: { container: true } },
    { path: 'projekte_status', name: 'admin-projekte-status', component: ExtraProjekteStatus, meta: { container: true } },
    { path: 'patientenverfuegung', name: 'admin-patientenverfuegung', component: ExtraPatientenverfuegung, meta: { container: false } },
    { path: 'ticket_vorgaben', name: 'admin-ticket-vorgaben', component: ExtraItTicketVorgabenBearbeiten, meta: { container: false } },
    { path: 'neues_geraet_hinzufuegen', name: 'admin-neues-geraet-hinzufuegen', component: ExtraNeuesGeraetHinzufuegen, meta: { container: false } },
    { path: 'inventar/:uid?', name: 'admin-inventar', component: ExtraInventar, meta: { container: false } },
    { path: 'prozesse', name: 'admin-prozesse', component: ExtraProzesse, meta: { container: false } },
    { path: 'qr_code_generator', name: 'admin-qrcode-generator', component: ExtraQrCodeGenerator, meta: { container: false } },
  ]},
  { path: '/inventar/:uid?', name: 'inventar', component: ExtraInventar, meta: { container: false } },
]

Object.values(menus).forEach(root => {
  buildMenuRoutes(root, routes, '')
})
routes.push({ path: '*', name: 'error404', component: Error404 })


const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const menuList = dataVueApp.menus
const kategorieList = dataVueApp.kategorien

export default router;
export { menus, user, menuList, kategorien, kategorieList };
